import { configureStore, createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
    name: "options",
    initialState: {
        headerWidth: 0,
        headerHeight: 0,
        menuIsOpen: false,
        cartIsOpen: false,
        langSelectorIsOpen: false
    },
    reducers: {
        setHeaderWidth: (state, action) => {
            state.headerWidth = action.payload;
            return state;
        },
        setHeaderHeight: (state, action) => {
            state.headerHeight = action.payload;
            return state;
        },
        openMenuMobile: (state, action) => {
            state.menuIsOpen = action.payload;
            return state;
        },
        openCart: (state, action) => {
            state.cartIsOpen = action.payload;
            return state;
        },
        openLangSelector: (state, action) => {
            state.langSelectorIsOpen = action.payload;
            return state;
        }
    }
})

export const { setHeaderWidth, setHeaderHeight, openMenuMobile, openCart, openLangSelector } = optionsSlice.actions;

// ------------------------------------------------------------------------------------------------

const cartSlice = createSlice({
    name: "cart",
    initialState: [],
    reducers: {
        setCart: (state, action) => {
            state = action.payload;
            if (!state || state.length === 0) localStorage.removeItem('cart_vanrah');
            
            return state;
        },
        removeFromCart: (state, { payload: { title_path, category_fr } }) => {
            const newState = state.filter(
                i =>
                    i.title_path !== title_path ||
                    (category_fr ? i.category_fr !== category_fr : false)
            );
            localStorage.setItem('cart_vanrah', JSON.stringify(newState));
            return newState;
        },
        changeQty: (state, { payload: { title_path, category_fr, qty } }) => {
            const item = state.find(
                i =>
                    i.title_path === title_path &&
                    (category_fr ? i.category_fr === category_fr : true)
            );
            if (item) item.quantity = qty;
            localStorage.setItem('cart_vanrah', JSON.stringify(state));
        }
    }
})

export const { setCart, removeFromCart, changeQty } = cartSlice.actions;

// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

export const store = configureStore({
    reducer: {
        options: optionsSlice.reducer,
        cart: cartSlice.reducer,
    }
});